<div mdbModal #modalInfo="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel" aria-hidden="true" [config]="{backdrop: true, ignoreBackdropClick: false}">
    <div class="modal-dialog " role="document">
        <div class="modal-content">
            <div class="modal-header" *ngIf="title">
                <h4 class="modal-title w-100" id="myModalLabel">{{ title }}</h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div *ngIf="contentText" class="modal-body">
                {{ contentText }}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary btn-sm waves-light" data-dismiss="modal"
                    (click)="cancel()" mdbWavesEffect>Cerrar</button>
                <!-- <button type="button" class="btn btn-primary btn-sm waves-light" (click)="accept()"
          mdbWavesEffect>Aceptar</button> -->
            </div>
        </div>
    </div>
</div>